/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { AgentStats } from "./AgentStats";
export const EnvironmentStats = core.serialization.object({
    agentExecutions: AgentStats.optional(),
});
